if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
    if (evt.submitter && evt.submitter.closest('.wk-button')) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      return;
    }
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);

  if (this.cart) {
    formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  // --- STEP 1: Collect checked addon products ---
  const addonInputs = document.querySelectorAll('.addon-checkbox input[type="checkbox"]:checked');
  const addonProducts = Array.from(addonInputs).map((input) => ({
    id: input.value,
    quantity: parseInt(formData.get('quantity')) || 1
  }));

  // --- STEP 2: Add main product first ---
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then(async (response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.description,
          message: response.message
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } 
      // else if (!this.cart) {
      //   window.location = window.routes.cart_url;
      //   return;
      // }
      // --- STEP 3: If addons exist, add them and update the response variable ---
      let updatedCartResponse = response;
      if (addonProducts.length > 0) {
        try {
          const addonConfig = fetchConfig('javascript');
          addonConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          addonConfig.headers['Content-Type'] = 'application/json';

          const addonBody = {
            items: addonProducts,
          };

          // Add sections and sections_url for drawer update
          if (this.cart) {
            addonBody.sections = this.cart.getSectionsToRender().map((s) => s.id);
            addonBody.sections_url = window.location.pathname;
          }

          const addonResponse = await fetch(`${routes.cart_add_url}`, {
            ...addonConfig,
            body: JSON.stringify(addonBody),
            method: 'POST'
          }).then((res) => res.json());

          // ✅ Update main response so we render cart with addons included
          updatedCartResponse = addonResponse;
        } catch (addonError) {
          console.error('Error adding addon products:', addonError);
        }
      }

      // --- STEP 4: Update cart content using final response ---
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id')
        });

      this.error = false;

      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              this.cart.renderContents(updatedCartResponse);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        // ✅ Render updated cart containing addons
        this.cart.renderContents(updatedCartResponse);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty'))
        this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    });
}



    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
